var n=function(n){n&&n.forEach((function(n,a){0!==a&&(n.style.display="none")}))};export{n as default};
